import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import productsService from '../services/products.service';

// Thunks asynchrones
export const fetchActiveProducts = createAsyncThunk(
  'products/fetchActive',
  async (_, { rejectWithValue }) => {
    try {
      return await productsService.getActiveProducts();
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Erreur lors du chargement des produits');
    }
  }
);

export const fetchProductById = createAsyncThunk(
  'products/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      return await productsService.getProductById(id);
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Produit introuvable');
    }
  }
);

export const fetchProductsByProfilAndAge = createAsyncThunk(
  'products/fetchByProfilAndAge',
  async ({ profilTypeId, agesSectionId }, { rejectWithValue }) => {
    try {
      return await productsService.getProductsByProfilAndAge(profilTypeId, agesSectionId);
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Erreur lors du chargement');
    }
  }
);

export const fetchProductsByType = createAsyncThunk(
  'products/fetchByType',
  async (productType, { rejectWithValue }) => {
    try {
      return await productsService.getProductsByType(productType);
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Erreur lors du chargement');
    }
  }
);

const productsSlice = createSlice({
  name: 'products',
  initialState: {
    items: [],
    kidProfileProducts: [],
    currentProduct: null,
    loading: false,
    error: null
  },
  reducers: {
    clearCurrentProduct: (state) => {
      state.currentProduct = null;
    },
    clearKidProfileProducts: (state) => {
      state.kidProfileProducts = [];
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch active products
      .addCase(fetchActiveProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActiveProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchActiveProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch product by ID
      .addCase(fetchProductById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentProduct = action.payload;
      })
      .addCase(fetchProductById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch by profil and age
      .addCase(fetchProductsByProfilAndAge.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsByProfilAndAge.fulfilled, (state, action) => {
        state.loading = false;
        state.kidProfileProducts = action.payload;
      })
      .addCase(fetchProductsByProfilAndAge.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch by type
      .addCase(fetchProductsByType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsByType.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchProductsByType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearCurrentProduct, clearKidProfileProducts, clearError } = productsSlice.actions;
export default productsSlice.reducer;
